<template>
  <div class="container">
    <van-cell-group class="group">
      <van-field
        placeholder="请输入快递名称"
        label="快递名称"
        v-model="form.name"
        clearable
      />
      <van-field
        placeholder="快递单号"
        label="快递单号"
        v-model="form.no"
        clearable
      />
    </van-cell-group>

    <div class="flex-column">
      <div class="waring">
        <div class="image">
          <img src="../../../assets/images/waring.png" alt />
        </div>
        <div class="text">
          <p>当天购买可立即退款，第二天需联系客服退款。</p>
          <p>客服电话：400-8658777</p>
        </div>
      </div>
      <div class="bottom" @click="onSubmit(form)">
        <button class="button">提交</button>
      </div>
    </div>
  </div>
</template>
<script>
import {
  CellGroup,
  Form,
  Field,
  Notify,
  Button,
  Toast,
  Picker,
  Dialog
} from "vant";
import service from "../../api/order/index";
import { dateFormat } from "../../util/date";
export default {
  components: {
    [CellGroup.name]: CellGroup,
    [Form.name]: Form,
    [Field.name]: Field,
    [Notify.name]: Notify,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Picker.name]: Picker,
    [Dialog.name]: Dialog
  },
  data() {
    return {
      form: {
        name: "",
        no: ""
      },
      orderId: "",
    };
  },

  methods: {
    onSubmit(form) {
      
        if (form.name == "") {
          Notify({ type: "danger", message: "请输入快递名称" });
          return;
        }
        if (form.no == "") {
          Notify({ type: "danger", message: "请输入快递单号" });
          return;
        }

      Dialog.confirm({
        message: "请确认填入的信息是否正确，如果信息错误退款将不会通过"
      })
        .then(() => {
          // on confirm
          console.log(form,85)
          service.refund(form, this.orderId).then((res) => {
            if (res.statusCode == 200) {
              Toast("退款申请成功");
              this.$router.push("myorder?orderStatusId=");
            }else{
              Toast(res.errors);
            }
          }).catch(err=>{
            // Toast(err);
          });
        })
        .catch(() => {
          // on cancel
        });
      // console.log(form);
    }
  },
  mounted() {
    this.orderId = this.$route.query.orderId;
  }
};
</script>
<style lang="less" scoped>
@deep: ~">>>";

.container {
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #fff;
  .van-cell {
    font-size: 4vw;
    height: 60px;
    padding: 0 6vw;
    line-height: 60px;
    @{deep}.van-field__label {
      color: #000;
    }
    @{deep}.van-field__control {
      font-size: 4vw;
    }
  }
  .van-cell__title, .van-cell__value{
      flex: none;
  }
  .bottom {
    margin-top: 25px;
    margin-bottom: 46px;
  }
  .button {
    width: 290px;
    height: 45px;
    font-size: 15px;
    background: #ee0a24;
  }
  .waring {
    width: 86.2vw;
    display: flex;
    align-items: center;
    padding-left: 3.46vw;
    background: #f8f8f8;
    margin-top: 2.4vw;
    .image {
      width: 4.26667vw;
      height: 4.26667vw;
    }
    .text {
      color: #888888;
      margin: 0;
      font-size: 3.2vw;
      margin-left: 3.2vw;
    }
  }
}
</style>